import Quill from 'quill';

const Parchment = Quill.import('parchment');
const Inline = Quill.import('blots/inline');

export const PointageLinkClass = Parchment.Attributor.Class('pointage-link', 'pointage-link', {
  scope: Parchment.Scope.INLINE,
});

export class PointageLinkFormat extends Inline {
  static create(): Node {
    return super.create();
  }

  static formats(): boolean {
    return true;
  }

  optimize(context: any): void {
    super.optimize(context);
    if (this.domNode.tagName !== this.statics.tagName[0]) {
      this.replaceWith(this.statics.blotName);
    }
  }
}
PointageLinkFormat.blotName = 'pointage-link';
PointageLinkFormat.className = 'pointage-link';
PointageLinkFormat.tagName = ['SPAN'];
